import { render, staticRenderFns } from "./SendVerifyToken.vue?vue&type=template&id=c4f9811c"
import script from "./SendVerifyToken.vue?vue&type=script&lang=js"
export * from "./SendVerifyToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports